import React from 'react'
import logo from 'assets/icons/logo.svg'
import CancelIcon from '@mui/icons-material/Cancel'
import { useNavigate } from 'react-router-dom'
import UIButton from 'component/ui/form/UIButton'
import UICard from 'component/ui/card/UICard'
import { APP_NAME } from 'config/common-consts'
import { Button } from '@mui/material'

const ErrorFallback = props => {
	const navigate = useNavigate()
	const { error, resetErrorBoundary } = props

	const retryChecking = () => {
		resetErrorBoundary()
	}

	const navigateToDashboard = () => {
		navigate('/home/dashboard')
		window.location.reload()
	}

	const buttonStyle = {
		color: '#fff',
		backgroundColor: '#3D2470',
		'&:hover': {
		  backgroundColor: '#9472db'
		}
	  };

	return (
		<>
			<div className="centered-justified-no-page">
				<div className="b1-primary my-3">
					<UICard
						customClasses="b1-primary shadow-lg p-5 m-md-5"
						jsx
						CardBody={
							<>
								<div className="d-flex justify-content-center align-items-center w-100 mb-4">
									<div className='d-flex justify-content-center align-items-center'>
										<img src={logo} alt="Enliv Logo" width={50} height={50} />
										&emsp;<span className="fm primary">{APP_NAME?.split('C')?.[0]}<span style={{fontWeight: 600}}>{APP_NAME?.split('v')?.[1]}</span></span>
									</div>
								</div>
								<p className="text-center mb-3">
									<CancelIcon
										style={{ fontSize: 60 }}
										color="error"
									/>
								</p>
								<p className="fs text-center">
									Something went wrong while handling your
									request, please retry or
									<br />
									navigate to home.
								</p>
								<small className="fxs text-center">
									<p>What went wrong?</p>
									<p className="text-danger">
										{error?.message || ''}
									</p>
								</small>
								<div className="d-flex justify-content-center align-items-center w-100 mt-4">
									<div>
										<Button sx={buttonStyle} onClick={retryChecking}>Retry</Button>
										&emsp;
										<Button sx={buttonStyle} onClick={navigateToDashboard}>Dashboard</Button>
									</div>
								</div>
							</>
						}
					/>
				</div>
			</div>
		</>
	)
}

export default ErrorFallback
